<template>
  <div class="bb-filter-extra" @click.stop>
    <div v-if="showList" class="bb-filter-extra-item"
         v-for="(item, index) in list"
         :key="index + item.title + item.prop">
      <div class="bb-filter-extra-item__title">{{item.title}}</div>
      <div class="bb-filter-extra-item-options">
        <checkbox
          class="bb-filter-extra-item-options__checkbox"
          checkbox-text="Yes"
          name="hasProperty"
          :section="item"
          :value.sync="item.valueHasProperty"
          @checkboxChange="checkboxChange"
        />
        <checkbox class="bb-filter-extra-item-options__checkbox"
                  checkbox-text="No"
                  name="hasNoProperty"
                  :section="item"
                  @checkboxChange="checkboxChange"/>
      </div>
    </div>
    <div v-if="showLanguages" class="bb-filter-extra-item">
      <div class="bb-filter-extra-item__title">{{language.title}}</div>
      <div class="bb-filter-extra-item-options">
        <checkbox class="bb-filter-extra-item-options__checkbox"
                  checkbox-text="Ru"
                  name="1"
                  :section="language"
                  @checkboxChange="checkboxLanguage"/>
        <checkbox class="bb-filter-extra-item-options__checkbox"
                  checkbox-text="En"
                  name="2"
                  :section="language"
                  @checkboxChange="checkboxLanguage"/>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Main/Inputs/checkbox'
export default {
  name: 'FilterExtraParameters',
  props: ['showLanguages', 'showList', 'filters', 'openFilter'],
  components: {Checkbox},
  data () {
    return {
      list: [
        {
          title: 'AOFC',
          prop: 'aofcExpDate',
          valueHasProperty: false
        },
        {
          title: 'TRN',
          prop: 'trn',
          valueHasProperty: false
        },
        {
          title: 'ESR Reportable',
          prop: 'esrReportable',
          valueHasProperty: false
        },
        {
          title: 'Audit Required',
          prop: 'auditExpDate',
          valueHasProperty: false
        },
        {
          title: 'E-channel',
          prop: 'eChannel.isActive',
          valueHasProperty: false
        }
      ],
      language: {
        title: 'Languages',
        prop: 'languages'
      }
    }
  },
  methods: {
    checkboxChange (value, type, item) {
      this.$emit('setFilter', value, type, item)
    },
    checkboxLanguage (value, type) {
      this.$emit('languageFilter', value, type)
    },
    setTrn () {
      const prop = 'trn'
      const trn = this.list.find((el) => el.prop === prop)
      const filterTrn = this.filters[prop] || {}
      const { hasProperty = false } = filterTrn
      trn.valueHasProperty = hasProperty
    },
    setDefaultValue () {
      this.setTrn()
    }
  },
  watch: {
    openFilter () {
      this.setDefaultValue()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-filter-extra {
    display: grid;
    grid-gap: 15px;
    align-items: center;

    &-item {
      display: grid;
      grid-gap: 5px;
      color: $color-black;
      font-size: 13px;
      line-height: 16px;
      font-weight: lighter;

      &__title {
        color: $color-accent;
        font-weight: normal;
      }

      &-options {
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/FilterExtraParameters.vue